export default{
    note: {
        index: 'note-index',
    }
}
